module.exports = __webpack_public_path__ + "assets/img/dollar-icon.049182b5.svg";